import React, { createContext, useContext } from "react";

const DemoContext = createContext({ isDemo: false, isDemoScene: () => false });

export const DemoProvider = ({ project, children }) => {
  const isDemo = Boolean(project?.is_demo);

  // Scene 6 is the "live generate" scene — not read-only
  const isDemoScene = (sceneNumber) => isDemo && sceneNumber <= 5;

  return (
    <DemoContext.Provider value={{ isDemo, isDemoScene }}>
      {children}
    </DemoContext.Provider>
  );
};

export const useDemo = () => useContext(DemoContext);
